// src/data/mockTemplates.ts
import { TemplateData } from '../types/Template.ts';

export const mockTemplates: TemplateData[] = [
  { id: 'tpl_sales_proposal', name: '営業提案書テンプレート', versions: ['v1.0', 'v1.1'] },
  { id: 'tpl_contract_basic', name: '基本契約書テンプレート', versions: ['v1.0'] },
  { id: 'tpl_faq_base', name: 'FAQテンプレート', versions: ['v1.0', 'v2.0'] },
];